module.exports = __webpack_public_path__ + "img/close.ab88595d.svg";